import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import moment from 'moment'

class InstanciaDescarga extends Component {
  render () {
    const {
      cpa
    } = this.props

    const fDestare = moment(cpa.fechaDeDestare).format('DD/MM/YYYY hh:mm a')

    return (
      <div>
        <div className='fechas-instancias'>
          <h6 className='texto-info'>Fecha de descarga: <br /> {fDestare}</h6>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  detalle: state.entregadores.detalle
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(InstanciaDescarga)
